import React from "react";
import ImageSlider from "../UI/ImageSlider/ImageSlider";
import classes from "./ExhibitionsOverview.module.css"

const ExhibitionsOverview = props =>{


    return <div className={classes.container}>
        <ImageSlider/>
    </div>
}
export default ExhibitionsOverview